import { useRef } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import Stats from "@/components/site/Stats";
import HowItWorks from "@/components/site/HowItWorks";
import WhyIFotoLife from "@/components/site/WhyIFotoLife";
import Testimonial from "@/components/site/Testimonial";
import LeadForm from "@/components/site/LeadForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const formRef = useRef(null);
  const goToMarketplace = () => {
    window.location.href = "https://ifotolife.shop";
  };

  return (
    <div className="bg-white min-h-screen" data-testid="landing-page">
      <Navbar onJoin={goToMarketplace} />
      <main>
        <Hero onJoin={goToMarketplace} />
        <EditorialMarquee />
        <Stats />
        <HowItWorks />
        <WhyIFotoLife />
        <Testimonial />
        <LeadForm innerRef={formRef} />
      </main>
      <Footer />
    </div>
  );
}
